/**
 * Reducer to manage xsell related state
 */

import { ActionTypes as types } from '../constants'

const initialState = {
  content: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.XSELL.DONE_XSELL_CONTENT:
      return {
        ...state,
        content: { ...action.data.xsell },
      }
    case types.TRANSACTION.LEAVING_SUCCESS_PAGE:
      return {
        initialState,
      }
    default:
      return state
  }
}
